$(function() {
    function toggleSearch() {
        $(".search-toolbar").hasClass("active") ? ($(".search-toolbar").hide().removeClass("active"), 
        $(".search-toolbar .search-input").val("")) : ($(".search-toolbar").show().addClass("active"), 
        $(".search-toolbar .search-input").focus());
    }
    function loadReadmore() {
        $("#product .tab-pane .description").readmore({
            speed: 75,
            maxHeight: 250,
            moreLink: '<a href="#"><i class="fa fa-angle-right"></i></a>',
            lessLink: "",
            beforeToggle: function(trigger) {
                $(trigger).hide();
            }
        });
    }
    function stopReadmore() {
        $("#product .tab-pane .description").readmore("destroy");
    }
    function addItem(form_id) {
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: $("#" + form_id).serialize(),
            success: cartSuccess,
            error: cartFailure
        });
    }
    function cartSuccess(data) {
        var elem = $(".addtocart");
        elem.removeAttr("disabled");
        var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1, cartCount = parseInt($("#cart-count").text()) + quantity;
        $("#cart-count").text(cartCount), console.log(data);
        var n = data.image.lastIndexOf("."), imageSrcParts = [ data.image.slice(0, n), "_thumb", data.image.slice(n) ], image = imageSrcParts.join(""), line_quantity = data.quantity.toString(), price = Shopify.formatMoney(data.line_price, $(".currency").attr("data")), matched = !1;
        if ($("#minicartform ul.cart-items > li").each(function() {
            parseInt($(this).attr("data-id")) === data.id && ($(this).find(".line-count").text(line_quantity), 
            $(this).find(".price").text(price), matched = !0);
        }), !matched) {
            var newItem = [ {
                img: image,
                quantity: line_quantity,
                price: price,
                id: data.id,
                title: data.title
            } ];
            "none" === $("#header .cart-details .form-wrapper").css("display") && ($("#header .cart-details .form-wrapper").show(), 
            $("#header .cart-details .cart-empty").hide()), $("#minicartform ul.cart-items").prepend($("#cartItemTemplate").render(newItem));
        }
        $("#header .cart-wrapper").addClass("hovered"), setTimeout(function() {
            $("#header .cart-wrapper").removeClass("hovered");
        }, 2e3);
    }
    function cartFailure() {}
    $(".toolbar-search a").click(function(e) {
        e.preventDefault(), toggleSearch();
    }), $(".search-toolbar .search-input").blur(toggleSearch), $(function() {
        $(".product-slide li").size() > 1 && $(".flexslider").flexslider({
            animation: "slide",
            slideshow: !1,
            animationLoop: !1,
            animationDuration: 700,
            slideshowSpeed: 6e3,
            controlsContainer: ".flex-controls",
            controlNav: !1,
            keyboardNav: !0,
            prevText: "",
            nextText: ""
        }).hover(function() {
            $(".flex-direction-nav").fadeIn();
        }, function() {
            $(".flex-direction-nav").fadeOut();
        }), $(".blog-articles li").size() > 1 && $(".blog-orbit").flexslider({
            animation: "slide",
            slideshow: !1,
            animationLoop: !1,
            animationDuration: 700,
            slideshowSpeed: 6e3,
            controlsContainer: ".flex-controls",
            controlNav: !1,
            keyboardNav: !0,
            prevText: "",
            nextText: ""
        }).hover(function() {
            $(".flex-direction-nav").fadeIn();
        }, function() {
            $(".flex-direction-nav").fadeOut();
        });
    }), window.innerWidth < 768 && loadReadmore(), $(window).resize(function() {
        window.innerWidth < 768 ? $("#product .tab-pane .description").hasClass("readmore-js-section") || loadReadmore() : $("#product .tab-pane .description").hasClass("readmore-js-section") && stopReadmore();
    }), $("form.contact-form").length > 0 && $("form.contact-form").validate({
        onkeyup: !1,
        onfocusout: !1,
        rules: {
            "contact[name]": {
                required: !0,
                maxlength: 32,
                minlength: 3
            },
            "contact[email]": {
                required: !0,
                email: !0
            },
            "contact[body]": {
                required: !0,
                maxlength: 3e3,
                minlength: 10
            }
        },
        messages: {
            "contact[name]": "Name must be between 3 and 32 characters!",
            "contact[email]": "Email Address does not appear to be valid!",
            "contact[body]": "Message must be between 10 and 3000 characters!"
        }
    }), $("form.comment-form").length > 0 && $("form.comment-form").validate({
        onkeyup: !1,
        onfocusout: !1,
        rules: {
            "comment[author]": {
                required: !0,
                maxlength: 32,
                minlength: 3
            },
            "comment[email]": {
                required: !0,
                email: !0
            },
            "comment[body]": {
                required: !0,
                maxlength: 3e3,
                minlength: 10
            }
        },
        messages: {
            "comment[author]": "Name must be between 3 and 32 characters!",
            "comment[email]": "Email Address does not appear to be valid!",
            "comment[body]": "Message must be between 10 and 3000 characters!"
        }
    }), $(".thumbs .image a").click(function(e) {
        e.preventDefault(), console.log(e.target);
        var largeImage = $(e.target).parent("a").attr("data-original-image");
        console.log(largeImage), $("#placeholder").attr("href", largeImage).children("img").attr("src", largeImage);
    }), $(".fancybox").fancybox({
        closeClick: !0,
        beforeLoad: function() {
            this.href = $("#placeholder").attr("href");
        }
    }), $("#cart a.update-cart").click(function(e) {
        e.preventDefault();
        var line = $(e.target).attr("data-line"), quantity = $(e.target).siblings(".item-quantity").val();
        document.location.href = "/cart/change?line=" + line + "&quantity=" + quantity;
    }), $(".addtocart").click(function(e) {
        var elem = $(this);
        $(elem).prop("disabled", !0), e.preventDefault(), addItem("add-item-form");
    }), $(".product-options .success-block .close").click(function(e) {
        e.preventDefault(), $(e.target).parents(".success-block").hide();
    }), $("#header nav.navbar ul.nav .caret-icon").click(function() {
        $(this).parent().toggleClass("open");
    });
});